import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import { alphaValueValidator } from 'utilities/validators';

import CiAlphaSliderComponent from './Component';
import { recalculateCutoffs } from '../shared';

class CiAlphaSliderContainer extends React.PureComponent {
  constructor (props) {
    super(props);

    this.handleChange = (_, newAlpha) =>
      this.props.recalculateCutoffs(newAlpha);
  }

  render () {
    return (
      <Field
        name="alpha"
        type="number"
        max={0.99999}
        min={0.00001}
        step={0.00001}
        onChange={this.handleChange}
        component={CiAlphaSliderComponent}
        validate={alphaValueValidator}
      />
    );
  }
}

CiAlphaSliderContainer.propTypes = {
  recalculateCutoffs: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  recalculateCutoffs
};

export default connect(null, mapDispatchToProps)(CiAlphaSliderContainer);
